// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/OpenSourcePage","hero":"OpenSourcePage-m__hero__f52bc3r7NM0"};